// extracted by mini-css-extract-plugin
module.exports = {"warp":"Delivery_warp__3sId6"};